import { Link, useLocation } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';

interface NavItem {
  label: string;
  href: string;
  icon: LucideIcon;
  badge?: number;
}

interface SidebarProps {
  navItems: (NavItem & { badge?: number })[];
  title: string;
}

export default function Sidebar({ navItems, title }: SidebarProps) {
  const location = useLocation();

  const activeHref = navItems
    .filter(
      (item) =>
        location.pathname === item.href ||
        location.pathname.startsWith(item.href + '/')
    )
    .sort((a, b) => b.href.length - a.href.length)[0]?.href;

  return (
    <aside className="w-64 glass-sidebar min-h-full sticky top-16">
      <div className="p-6">
        <h2 className="text-lg font-semibold text-gray-900 font-display">{title}</h2>
      </div>
      <nav className="px-3">
        {navItems.map((item) => {
          const isActive = item.href === activeHref;
          const Icon = item.icon;
          return (
            <Link
              key={item.href}
              to={item.href}
              className={`flex items-center px-4 py-3 mb-1 rounded-xl transition-all duration-200 ${
                isActive
                  ? 'bg-gold/10 text-gold border border-gold/30'
                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
              }`}
            >
              <Icon className={`w-5 h-5 mr-3 ${isActive ? 'text-gold' : ''}`} />
              <span className="flex-1">{item.label}</span>
              {item.badge !== undefined && item.badge > 0 && (
                <span className="bg-red-500 text-white text-xs rounded-full px-1.5 py-0.5 min-w-[20px] text-center font-medium">
                  {item.badge > 99 ? '99+' : item.badge}
                </span>
              )}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
